

<template>

	<div class="booking-mask booking-mask--vertical">

		<header class="booking-mask__header">
			
			<div class="booking-mask__datepicker">

				<label class="booking-mask__datepicker-title">{{msg.select_dates}}</label>
				<date-picker></date-picker>
				
			</div>

			<div class="booking-mask__dropdown booking-mask__dropdown--no-caret">

				<label class="booking-mask__dropdown-title booking-mask__dropdown-title--v2">{{msg.venue_type}}</label>

				<div class="c-select-dropdown">

					<input @click="showDropdown = !showDropdown" class="c-select-dropdown__trigger" readonly="true" type="text" name="" v-model="venueType">
					
					<transition name="dropdown-fade">
						<ul class="c-select-dropdown__list" v-show="showDropdown">
							<li class="c-select-dropdown__list-item">
								<span class="c-select-dropdown__list-subitem" :class="{'js-active': venueType == 'Meeting rooms 1'}" @click="changeVenue">{{msg.meeting_rooms}} 1</span>
							</li>
							<li class="c-select-dropdown__list-item">
								<span class="c-select-dropdown__list-subitem" :class="{'js-active': venueType == 'Meeting rooms 2'}" @click="changeVenue">{{msg.meeting_rooms}} 2</span>
							</li>
							<li class="c-select-dropdown__list-item">
								<span class="c-select-dropdown__list-subitem" :class="{'js-active': venueType == 'Meeting rooms 3'}" @click="changeVenue">{{msg.meeting_rooms}} 3</span>
							</li>
							<li class="c-select-dropdown__list-item">
								<span class="c-select-dropdown__list-subitem" :class="{'js-active': venueType == 'Meeting rooms 4'}" @click="changeVenue">{{msg.meeting_rooms}} 4</span>
							</li>
							<li class="c-select-dropdown__list-item">
								<span class="c-select-dropdown__list-subitem" :class="{'js-active': venueType == 'Meeting rooms 5'}" @click="changeVenue">{{msg.meeting_rooms}} 5</span>
							</li>
						</ul>
					</transition>
					
				</div>

			</div>

		</header>


		<footer class="booking-mask__footer">

			<input class="input-text input-text--lg input-text--mr" type="text" name="person" v-model="person" placeholder="Contact person">

			<input class="input-text input-text--mr" type="text" name="organisation" v-model="organisation" placeholder="Organisation">

			<input class="input-text input-text--mr" type="text" name="mail" v-model="mail" placeholder="email">

			<button class="booking-mask__btn btn btn-primary btn-primary--invert">Send</button>
			
		</footer>


	</div>

</template>
<script>
// import HotelDatePicker from 'vue-hotel-datepicker';
import { directive as onClickaway } from 'vue-clickaway';
import { mapState } from "vuex";

export default {
	
	data: () => ({
		venueType: 'Meeting rooms 1',
		showDropdown: false,
		person: '',
		organisation: '',
		mail: ''
	}),
	mounted() {
		let self = this;

		window.addEventListener('click', function(e){
			// console.log(e.target, 'click');
			// close dropdown when clicked outside
			if (!e.target.classList.contains('c-select-dropdown__trigger')) {
				// console.log('entered');
				self.showDropdown = false;
			} 
		});
	},
	methods: {
		activateDropdown() {
			this.showDropdown = true;
		},
		changeVenue(event) {
			// console.log(event.target.innerHTML);
			this.venueType = event.target.innerHTML;
		}
	},
	computed: {
		...mapState({
				msg: state => state.msg,
			})
	},
	directive: {
		onClickaway: onClickaway,
	}

};
</script>
<style>
</style>